import { render, staticRenderFns } from "./ProductRowColumn2.vue?vue&type=template&id=bc9aa434&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./ProductRowColumn2.vue?vue&type=script&lang=ts"
export * from "./ProductRowColumn2.vue?vue&type=script&lang=ts"
import style0 from "./ProductRowColumn2.vue?vue&type=style&index=0&id=bc9aa434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9aa434",
  null
  
)

export default component.exports